import Create from "./Create";
import List from "./List";
import Update from "./Update";

export const PaymentMethod = {
  List: List,
  Update: Update,
  Create: Create,
  Permissions: {
    create: "create:PaymentMethod",
    read: "read:PaymentMethod",
    list: "list:PaymentMethod",
    update: "update:PaymentMethod",
    delete: "delete:PaymentMethod",
  },
};
